var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUdendoersfitnessMotionsplads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.509,3.088a.5.5,0,0,0-.5.5v.7H8.635v-.7a.5.5,0,1,0-1,0V5.7H3.472V5.444a.5.5,0,0,0-1,0V12a.5.5,0,0,0,1,0V6.453H7.635V12a.5.5,0,0,0,1,0v-1.3h3.374V12a.5.5,0,1,0,1,0V3.588A.5.5,0,0,0,12.509,3.088ZM8.635,5.035h3.374V5.7H8.635Zm0,2.835h3.374v.667H8.635Zm3.374-1.417V7.12H8.635V6.453ZM8.635,9.287h3.374v.668H8.635Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdendoersfitnessMotionsplads);
export default __webpack_public_path__ + "static/media/UDENDOERSFITNESS-MOTIONSPLADS.dea379f2e353d1762802bfb2add708db.svg";
export { ForwardRef as ReactComponent };